import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const Kpi = ({ label, value, icon, tone }) => (
    <div className="emp-kpi">
        <span className={`emp-kpi-icon ${tone}`}><Icon icon={icon} /></span>
        <span className="emp-kpi-label">{label}</span>
        <span className="emp-kpi-value">{value ?? 0}</span>
    </div>
);

// Compact horizontal breakdown bar list (society / type), sorted desc by the API already.
const Breakdown = ({ title, icon, rows, nameKey }) => {
    const items = Array.isArray(rows) ? rows.slice(0, 5) : [];
    const max = items.reduce((m, r) => Math.max(m, r.count || 0), 0) || 1;
    return (
        <div className="col-md-6 col-lg-4">
            <div className="emp-panel">
                <div className="emp-panel-title">
                    <Icon icon={icon} className="text-primary-600 text-sm" />{title}
                </div>
                <div className="emp-bars">
                    {items.length === 0 ? (
                        <p className="text-secondary-light text-xs mb-0">No data</p>
                    ) : (
                        items.map((r, i) => (
                            <div key={i} className="emp-bar-row">
                                <div className="emp-bar-head">
                                    <span className="text-secondary-light text-truncate">{r[nameKey] || '—'}</span>
                                    <span className="fw-semibold text-primary-light">{r.count ?? 0}</span>
                                </div>
                                <div className="emp-bar-track">
                                    <div className="emp-bar-fill"
                                        style={{ width: `${Math.round(((r.count || 0) / max) * 100)}%` }} />
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

const EmployeeStatsCards = ({ stats, loading }) => {
    const s = stats || {};
    const v = (x) => (loading ? '…' : x);
    return (
        <div className="row g-3 mb-20">
            <div className="col-md-12 col-lg-4">
                <div className="emp-panel">
                    <div className="emp-panel-title">
                        <Icon icon="mdi:chart-box-outline" className="text-primary-600 text-sm" />Overview
                    </div>
                    <Kpi label="Total Employees" value={v(s.total)} icon="mdi:account-group-outline" tone="bg-primary-50 text-primary-600" />
                    <Kpi label="Active" value={v(s.active)} icon="mdi:account-check-outline" tone="bg-success-focus text-success-main" />
                    <Kpi label="Inactive" value={v(s.inactive)} icon="mdi:account-off-outline" tone="bg-danger-focus text-danger-main" />
                </div>
            </div>
            <Breakdown title="By Community" icon="mdi:office-building-outline" rows={s.by_society} nameKey="name" />
            <Breakdown title="By Employee Type" icon="mdi:badge-account-horizontal-outline" rows={s.by_type} nameKey="type" />
        </div>
    );
};

export default EmployeeStatsCards;
